import React from "react";
import { Turnstile } from "@marsidev/react-turnstile";
import { getI18NMessage } from "./../../../i18n/I18N";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import UI_CONSTANTS from "../../app/constants/UIConstants";
import AppUtil, { getAppURL } from "./../../../utils/AppUtil";
import { validateCaptcha } from "../actions/LoginActions";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InfoRounded from "@mui/icons-material/InfoRounded";

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tooManyRequest: false,
      locked: false,
      turnstileToken: null,
      widgetKey: 0
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.sendForpassword = this.sendForpassword.bind(this);
    this.validateCaptchaAndSendForpassword =
      this.validateCaptchaAndSendForpassword.bind(this);
  }

  render() {
    const { appUrlHash, captcha } = this.props;
    const { locked } = this.state;
    const enableSubmit = (this.state.username || "").trim();
    const invalidUsername =
      appUrlHash && appUrlHash.indexOf(UI_CONSTANTS.INVALID_URL_HASH) !== -1;
    let helperTextUsername = invalidUsername
      ? getI18NMessage("invalidusername")
      : "";

    if (this.state.tooManyRequest) {
      helperTextUsername = getI18NMessage("tooFrequentRequest");
    }

    return (
      <React.Fragment>
        <form
          id="sso-form-forgotpassword"
          onSubmit={this.onSubmit}
          action="/rest/v1/users/forgotpassword"
          method="post"
        >
          <TextField
            size="small"
            label={getI18NMessage("loginid")}
            name="username"
            className="lg-username"
            fullWidth
            autoFocus
            onChange={this.onInputChange}
            onBlur={this.onInputChange}
            error={invalidUsername}
            helperText={helperTextUsername}
          />
          {captcha && (
            <Turnstile
              siteKey={captcha.sitekey}
              options={{ action: "forgot-password", theme: "light", size: "flexible" }}
              key={this.state.widgetKey}
              onSuccess={token => this.setState({ turnstileToken: token })}
              onExpire={() => this.setState({ turnstileToken: null })}
              onError={() => this.setState({ turnstileToken: null })}
            />
          )}
          {locked && (
            <FormControl error={Boolean(locked)}>
              {locked && (
                <FormHelperText>
                  {getI18NMessage("accountLocked")}
                </FormHelperText>
              )}
            </FormControl>
          )}
          <div className="lg-form-buttons">
            <Button
              variant="contained"
              disabled={!enableSubmit}
              onClick={
                captcha
                  ? this.validateCaptchaAndSendForpassword
                  : this.sendForpassword
              }
            >
              {getI18NMessage("submit")}
            </Button>
            <a href="#">{getI18NMessage("backtologin")}</a>
          </div>
        </form>
        <div className="fp-info">
          <InfoRounded className="fp-info-icon" />
          {getI18NMessage("fpinfo")}
        </div>
        <a
          id="lg-invalid-reset-username"
          className="lg-form-hidden"
          href={`${UI_CONSTANTS.FORGOT_PW_URL_HASH}${UI_CONSTANTS.INVALID_URL_HASH}`}
        />
        <a
          id="lg-valid-reset-username"
          className="lg-form-hidden"
          href={`?username=${encodeURIComponent(this.state.username)}${UI_CONSTANTS.FORGOT_PW_EMAIL_URL_HASH}`}
        />
        <a
          id="lg-navigate-account-lockout"
          href={`${UI_CONSTANTS.FORGOT_PW_URL_HASH}${UI_CONSTANTS.ACCOUNT_LOCKOUT}`}
          className="lg-form-hidden"
        />
      </React.Fragment>
    );
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  validateCaptchaAndSendForpassword() {
    validateCaptcha(
      this.state.turnstileToken,
      this.setState.bind(this),
      this.sendForpassword,
      "forgot-password"
    );
  }

  sendForpassword() {
    const URL = getAppURL("FORGOT_PASSWORD");

    AppUtil.ajax(
      URL,
      {
        username: this.state.username
      },
      response => {
        if (response.status === 401) {
          this.setState(prev => ({
            tooManyRequest: false,
            turnstileToken: null,
            widgetKey: prev.widgetKey + 1
          }));
          document.getElementById("lg-invalid-reset-username").click();
        } else if (response.status === 403) {
          this.setState(prev => ({
            locked: true,
            turnstileToken: null,
            widgetKey: prev.widgetKey + 1
          }));
          document.getElementById("lg-navigate-account-lockout").click();
        } else if (response.status === 429) {
          this.setState(prev => ({
            tooManyRequest: true,
            turnstileToken: null,
            widgetKey: prev.widgetKey + 1
          }));
        } else {
          document.getElementById("lg-valid-reset-username").click();
        }
      },
      () => {
        this.setState(prev => ({
          tooManyRequest: false,
          turnstileToken: null,
          widgetKey: prev.widgetKey + 1
        }));
        document.getElementById("lg-invalid-reset-username").click();
      },
      true
    );
  }

  onSubmit(event) {
    event.preventDefault();

    if (this.props.captcha) {
      this.validateCaptchaAndSendForpassword();
    } else {
      this.sendForpassword();
    }

    return Boolean((this.state.username || "").trim());
  }
}

export default ForgotPassword;
